import {
    IOrderDataHandler,
    IOrderProductDeclineForm,
} from '../../data-handlers/order/IOrderDataHandler'
import { OrderProduct } from '../../entities/order-product/OrderProduct'

export class OrderRepository {
    handler: IOrderDataHandler

    constructor(handler: IOrderDataHandler) {
        this.handler = handler
    }

    acceptProduct(product: OrderProduct): Promise<void> {
        return this.handler.acceptProduct(product)
    }

    declineProduct(
        product: OrderProduct,
        declineData: IOrderProductDeclineForm
    ): Promise<void> {
        return this.handler.declineProduct(product, declineData)
    }

    gotIt(
        orderId: number,
        productId?: number,
        customWay?: 'from-modal' | 'from-column'
    ): Promise<void> {
        return this.handler.gotIt(orderId, productId, customWay)
    }

    changeStatus(orderId: number, nextStatus: string): Promise<void> {
        return this.handler.changeStatus(orderId, nextStatus)
    }
}
